import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCtaStittsville() {
  return <section data-section-id="241175" id="final-cta-stittsville" className="relative overflow-hidden bg-background py-32 sm:py-48">
      {}
      <svg className="absolute top-0 left-0 w-full h-16 md:h-32 text-primary/10 fill-current z-10 pointer-events-none" preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true">
        <polygon points="0,0 100,0 100,100 0,0" />
      </svg>

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] sm:w-[1000px] sm:h-[1000px] bg-[radial-gradient(circle,var(--color-secondary)_0%,transparent_60%)] opacity-10 dark:opacity-20 blur-3xl animate-pulse rounded-lg"></div>
      </div>

      <div className="relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl sm:text-5xl md:text-7xl font-bold tracking-tighter uppercase text-foreground mb-6 max-w-4xl drop-shadow-sm">
          Ready to Remove Your Junk?
        </h2>
        
        <p className="font-default text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto mb-12">
          Book fast affordable junk removal in Stittsville today.
        </p>

        <Link to="/PricingPage">
          <Button size="lg" className="group relative h-auto overflow-hidden rounded-lg px-10 py-5 text-lg sm:text-xl font-semibold transition-all duration-500 hover:scale-110 hover:shadow-xl bg-secondary text-secondary-foreground border border-secondary/20">
            <span className="relative z-10 flex items-center gap-3">
              Get Your Free Quote
              <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1.5" />
            </span>
            {}
            <div className="absolute inset-0 bg-primary/10 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out rounded-lg"></div>
          </Button>
        </Link>
      </div>

      {}
      <svg className="absolute bottom-0 left-0 w-full h-16 md:h-32 text-primary/10 fill-current z-10 pointer-events-none" preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true">
        <polygon points="0,100 100,100 100,0 0,100" />
      </svg>
    </section>;
}